const MODULE_URL = 'share_profiles';
export default {
  MODULE_URL: MODULE_URL,
  PROFILES_URL: MODULE_URL,

  PROFILE_ADDED: 'share_profile_added',
  PROFILE_UPDATED: 'share_profile_updated',
  PROFILE_REMOVED: 'share_profile_removed',

  HIDDEN_PROFILE_ID: 1,
};
